module.exports = "/assets/ce8df0dd45c61c3c9844905b5287a84b.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LN.png
// module id = 2709
// module chunks = 0